<template>
	<div class="user_main_settings">
		<div class="d-flex flex-start w-100">
			<div class="mr-2 hidden-md-down">
            <span class="icon-stack icon-stack-lg">
                <i class="base base-6 icon-stack-3x opacity-100 color-primary-500"></i>
                <i class="ni ni-phone icon-stack-1x opacity-100 color-white"></i>
            </span>
			</div>
			<div class="d-flex flex-fill">
				<div class="flex-fill">
					<span class="h5">Налаштування параметрів користувача</span>
				</div>
			</div>
		</div>

		<div class="row pt-5">
			<div class="col-lg-4 col-md-4 col-xs-12 col-xl-4 pb-4">
				<div class="panel-tag">
					Службові записки
				</div>

				<div class="form-group mt-2">
					<label class="form-label" for="organization">
						Організація за замовчуванням
					</label>

					<div class="" v-if="organizations.length > 0">
					<v-select
							  v-model="user.org_def"
							  :reduce="organization => organization.id"
							  class="imc_reasons"
							  label="small_title"
							  :options="this.organizations"
							  :filterable="true"
					>
						<template slot="no-options">
							Оберіть організацію
						</template>

						<template slot="option" slot-scope="option">
							<div class="d-flex p-1 mr-2">
								<div class='icon-stack fs-xxl'>
									<i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
									<i class="base base-7 icon-stack-2x opacity-100 color-primary-300"></i>
									<i class="fal fa-bookmark icon-stack-1x opacity-100 color-white"></i>
								</div>

								<div class="org_title ml-2">
									{{ option.small_title }}
								</div>
							</div>
						</template>
					</v-select>
				</div>
				</div>

				<div class="form-group mt-2">
					<label class="form-label" for="service">
						Служба за замовчуванням
					</label>

					<div class="" v-if="services.length > 0">
						<v-select
							v-model="user.service_def"
							:reduce="service => service.id"
							class="imc_reasons"
							label="title"
							:options="this.services"
							:filterable="true"
						>
							<template slot="no-options">
								Оберіть службу
							</template>

							<template slot="option" slot-scope="option">
								<div class="d-flex p-1 mr-2">
									<div class='icon-stack fs-xxl'>
										<i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
										<i class="base base-7 icon-stack-2x opacity-100 color-primary-300"></i>
										<i class="fal fa-bookmark icon-stack-1x opacity-100 color-white"></i>
									</div>

									<div class="org_title ml-2">
										{{ option.title }}
									</div>
								</div>
							</template>
						</v-select>
					</div>
				</div>

				<div class="form-group mt-2">
					<label class="form-label">
						Повідомлення службових по e-mail
					</label>

					<div class="input-group flex-nowrap">
						<b-form-radio-group
							id="btn-radios-1"
							v-model="user.email_send"
							button-variant="outline-primary"
							:options="[
                                          { text: 'ТАК', value: 1 },
                                          { text:  'НІ', value: 0 }
                                      ]"
							name="radios-btn-default"
							buttons
						></b-form-radio-group>
					</div>
				</div>
			</div>

			<div class="col-lg-4 col-md-4 col-xs-12 col-xl-4 pb-4">
				<div class="panel-tag">
					Налаштування Аукціону землі
				</div>

				<div class="form-group mt-2">
					<label class="form-label">
						Учасник продажу ЗД співробітнику ІМК
					</label>
					<div class="input-group flex-nowrap">
						<b-form-radio-group
							id="btn-radios-1"
							v-model="land_settings.auction_in"
							button-variant="outline-primary"
							:options="[
                                          { text: 'ТАК', value: 1 },
                                          { text:  'НІ', value: 0 }
                                      ]"
							name="radios-btn-default"
							buttons
						></b-form-radio-group>
					</div>
				</div>

				<div class="form-group mt-2">
					<label class="form-label" for="basic-url">Фільтр дохідності % >=</label>
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text"> % </span>
						</div>

						<b-form-input v-model="land_settings.auction_percent"
									  class="form-control"
									  placeholder="Фільтр дохідності % >=">
						</b-form-input>
					</div>
				</div>

				<div class="form-group mt-2">
					<label class="form-label" for="service">
						Організації, де Ви хочете придбати землю
					</label>

					<div class="" v-if="organizations.length > 0">
						<v-select
							multiple
							v-model="land_settings.tovs_auction"
							:reduce="organization => organization.id"
							class="imc_reasons"
							label="small_title"
							:options="this.organizations"
							:filterable="true"
						>
							<template slot="no-options">
								Оберіть Організацію
							</template>

							<template slot="option" slot-scope="option">
								<div class="d-flex p-1 mr-2">
									<div class='icon-stack fs-xxl'>
										<i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
										<i class="base base-7 icon-stack-2x opacity-100 color-primary-300"></i>
										<i class="fal fa-bookmark icon-stack-1x opacity-100 color-white"></i>
									</div>

									<div class="org_title ml-2">
										{{ option.small_title }}
									</div>
								</div>
							</template>
						</v-select>
					</div>
				</div>

			</div>
		</div>

		<div class="next_step text-right">
			<button type="button"
					v-on:click="save_settings"
					class="btn btn-lg btn-outline-primary waves-effect waves-themed save_user_settings">
				<span class="fal fa-check mr-1"></span>
				Зберегти
			</button>
		</div>

	</div>
</template>

<script>
import {mapGetters} from "vuex";
import vSelect from 'vue-select'

export default {
	name: "main_settings",

	components : {
		vSelect
	},

	props : {
		user_id : {
			type : Number,
			required : true
		}
	},

	data() {
		return {
			organizations : [],
			services : [],
			land_settings : {
				auction_in : 0,
				auction_percent : 0,
				tovs_auction : []
			},
		}
	},

	created() {
		this.load_params();
	},

	methods : {

		async save_settings() {
			this.$emit('loading','main_settings',true);
			await api.put('/user/' + this.user_id + "/params",{
				'basic' : this.user_params,
				'land' 	: this.land_settings
			}).then(({data}) => {
				this.$emit('loading','main_settings',false);
				if(data.status === "operation_success") {
					this.$store.dispatch('user/LOAD_USER');
					this.load_land_settings();
				}
			}).catch(({response}) => {
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
				this.$emit('loading','main_settings',false);
			});
		},

		load_params() {
			this.get_org_list();
			this.load_service();
			this.load_land_settings();
		},

		async load_land_settings() {
			await api.get('/user/' + this.user_id + "/params/land").then(({data}) => {
				if(data.status === "operation_success") {
					this.land_settings = data.data;
				}
			}).catch(err => {
				console.log(err);
			});
		},

		async load_service() {
			await api.get('/departments').then(({data}) => {
				if(data.status === "operation_success") {
					this.services = data.data;
				}
			}).catch(err => {
				console.log(err);
			});
		},

		async get_org_list() {

			await api.get('/organizations').then(({data}) => {
				if(data.status === "operation_success") {
					this.organizations = data.data;
				}
			}).catch(err => {
				console.log(err);
			});
		}

	},

	computed : {
		...mapGetters({
			'user': "user/getUser",
		}),


		user_params () {
			return {
				org_def 	: this.user.org_def,
				service_def : this.user.service_def,
				email_send  : this.user.email_send,
			}
		},

	},

}
</script>

<style scoped>

</style>
